import AboutImage from "../images/about.png";

const About = () => {
  return (
    <section id="company" className="w-full">
      <div className="flex flex-col lg:flex-row bg-gradient-to-r from-stone-300 to-orange-50 shadow-lg overflow-hidden pt-4 md:pt-6 pb-8 min-h-[500px]">
        {/* Text Content (Left Side - Adjusted Width for Better Responsiveness) */}
        <div className="w-full lg:w-2/3 p-6 md:p-12 flex flex-col justify-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-sky-950">
            Company Overview
          </h2>
          <div className="space-y-4 md:space-y-6 text-gray-700 leading-relaxed text-base md:text-lg lg:text-xl xl:text-2xl text-justify">
            <p>
              <strong>Let's Trade Africa</strong> is a leading Agricultural Commodity Trading company that focuses on sourcing and distributing premium-quality grains and agricultural products.        
              Driven by our Vision, Mission, and Values, our strength lies in strategic sourcing, with a core emphasis on service excellence, quality, and cost-effectiveness. We provide flexible, tailored supply chain solutions to cater to the unique needs of our diverse customer base.
            </p>
            <p>
              Instead of prioritizing high volumes, we prioritize customer satisfaction by recognizing and addressing the distinct requirements of each client. Our business is committed to building strong relationships with Zimbabwe, Malawi and South Africa's leading commercial growers, offering them innovative market and currency risk solutions.
            </p>
            <p>
              The enthusiastic team at Let's Trade delivers consistent and reliable service every day, throughout the seasons and across the years. With an extensive network of suppliers and buyers, we maintain a seamless supply chain that ensures exceptional value for farmers, processors, and consumers nationwide.
            </p>
          </div>
        </div>

        {/* Image (Right Side - Now Properly Scaled) */}
        <div className="w-full lg:w-1/3 flex justify-center lg:justify-end">
          <img 
            src={AboutImage} 
            alt="About Let's Trade" 
            className="w-full max-w-[400px] md:max-w-[500px] lg:max-w-[450px] h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
